import {PageSubContainerSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function RolePending() {
  return (
    <PageSubContainerSkeleton>
      <Skeleton className="h-8 w-48 rounded-md" />
      <Skeleton className="h-5 w-72 rounded-md" />
    </PageSubContainerSkeleton>
  );
}
